"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getRouterRootFromOneOptions_exports = {};
__export(getRouterRootFromOneOptions_exports, {
  getRouterRootFromOneOptions: () => getRouterRootFromOneOptions
});
module.exports = __toCommonJS(getRouterRootFromOneOptions_exports);
function getRouterRootFromOneOptions(options) {
  var _options_router;
  return (options === null || options === void 0 ? void 0 : (_options_router = options.router) === null || _options_router === void 0 ? void 0 : _options_router.root) || process.env.ONE_ROUTER_ROOT || "app";
}
//# sourceMappingURL=getRouterRootFromOneOptions.js.map
